function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
};
export const {width, height} = getWindowDimensions();
export * from "./apiClient";
export * from "./config";
export * from "./utils";
export * from "./storage";
export * from "./persistAtom";
